import { map } from 'lodash';

const SESSION_PIXEL_DATA_NAME = 'pixel-data';

export const jellybeanTracker = {
  init: (jellybeans, isMobile) => {
    const self = jellybeanTracker;
    const trackers = map(jellybeans, jellybean => {
      const jellybeanUrlMobile = self.getJellyBeanUrlMobile(jellybean);
      const jellybeanUrlWired = self.getJellyBeanUrlWired(jellybean);
      const jellybeanUrl = self.getJellyBeanUrl(isMobile, jellybeanUrlMobile, jellybeanUrlWired);
      const typePixelTracker = self.getTypePixeltracker(isMobile, jellybean);
      return { jellybeanUrl, typePixelTracker };
    });

    sessionStorage.setItem(SESSION_PIXEL_DATA_NAME, JSON.stringify(trackers));
  },

  getJellyBeanUrlMobile: jellybean => jellybean.adUrlMobile || jellybean.url,

  getJellyBeanUrlWired: jellybean => jellybean.adUrl || jellybean.url,

  getJellyBeanUrl: (isMobile, jellybeanUrlMobile, jellybeanUrlWired) =>
    isMobile ? jellybeanUrlMobile : jellybeanUrlWired,

  getTypePixeltracker: (isMobile, jellybean) => (isMobile ? jellybean.clickTrackerMobile : jellybean.clickTracker),
};

export const handlePixelData = {
  init: (ref, location) => {
    const self = handlePixelData;

    if (!self.isHomepageReferrer(document.referrer)) return;

    const sessionPixelData = JSON.parse(sessionStorage.getItem(SESSION_PIXEL_DATA_NAME)) || [];
    const hashValue = self.getHashValue(location);
    const host = window.location.host.toString();
    const pathname = window.location.toString().split(host)[1];
    const targetJellybean = self.getTargetJellybean(sessionPixelData, pathname);

    if (self.enableFirePixelTracker(targetJellybean, pathname, hashValue, ref)) {
      self.setBackgroundImageWithPixel(targetJellybean.typePixelTracker, ref);
    }
  },

  isHomepageReferrer: url => {
    const referrer = document.createElement('a');
    referrer.href = url;

    return !!referrer.hostname.match(/edmunds.com/g) && referrer.pathname === '/';
  },

  setBackgroundImageWithPixel: (pixel, ref) => {
    const reference = ref;
    reference.current.style.backgroundImage = `url(${pixel})`;
  },

  removeSessionItem: () => {
    sessionStorage.removeItem(SESSION_PIXEL_DATA_NAME);
  },

  enableFirePixelTracker: (targetJellybean, pathname, hashValue, ref) =>
    !!targetJellybean && !!(targetJellybean.jellybeanUrl === pathname) && !!hashValue && !!(ref && ref.current),

  getTargetJellybean: (data, pathname) => data.filter(obj => obj.jellybeanUrl === pathname)[0] || {},

  getHashValue: location => (location && location.hash ? location.hash : ''),
};
